import moment from 'moment';
import getItemStyles from '../../../utils/item-styles';
import ignoreDummyComments from '../../../../../utils/ignoreDummyComments';

/**
 * Returns a formatted day off item for the seven to nine day posted schedule.
 * @param {*} resource
 * @param {*} dayType
 */
const generateOffTime = (resource, dayType, dayOffStartTime) => {
  const { rId } = resource;
  const { rdtId, dayTypeName } = dayType
  const { dorId, abbreviation, dayTypeComment, myDayTypeComment, isApproved, wbse, showCostObjectId, costCenter } = dayType.dayOff;
  let hasComment = false;
  if ( ignoreDummyComments(dayTypeComment || myDayTypeComment) ) {
    hasComment = true;
  }

  const offTimeStyle = getItemStyles('offtime');
  const offTime = {
    id: rdtId,
    itemType: 'off-time',
    group: rId,
    dorId,
    title: abbreviation,
    abbreviation,
    start_time: moment(dayOffStartTime).startOf('day'),
    end_time: moment(dayOffStartTime).endOf('day'),
    dayTypeComment,
    myDayTypeComment,
    backgroundColor: dayType.dayOff.isApproved ? "gray" : offTimeStyle.backgroundColor,
    color: offTimeStyle.color,
    borderStyle: offTimeStyle.borderStyle,
    borderColor: hasComment ? "red" : offTimeStyle.borderColor, isApproved,
    isApproved,
    wbse,
    showCostObjectId,
    costCenter
  };

  return offTime;
}

export default generateOffTime;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/generate-timeline/generateOfftime.js